import { all, fork } from "redux-saga/effects";
import trailsSaga from "./trailSaga";
import pageSaga from './pageSaga';


export default function* rootSaga() {
  yield all([fork(trailsSaga),fork(pageSaga)]);
}
